export default __webpack_public_path__ + "static/media/hero-positive-verification.a751538e.svg";